const countOwners = (owners) => {
  const ownersObject = owners.reduce((acc, curr) => {
    if (typeof acc[curr] === 'undefined') {
      acc[curr] = 1
    } else {
      acc[curr] += 1
    }
    return acc
  }, {})
  return ownersObject
}

export default countOwners



// WEBPACK FOOTER //
// ./src/logic/countOwners.js